export const DAO_CODE = 'PAYMENT' + '_METHOD' + '_DAO';
